<app-nf-geo-map #geomap class="h-100 w-100" [center]="center" [extent]="extent" [zoom]="zoom" [layers]="layers" [minZoom]="minZoom" [maxZoom]="maxZoom"
    [mapboxStyle]="mapBoxStyle" [mapboxKey]="mapBoxToken" (mapReady)="mapReady($event)">
</app-nf-geo-map>